import React, { useContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { MessagingTokenContext } from './MessagingTokenProvider';
import useChatUserExists from '@hooks/useChatUserExists';
import useViewer from '@hooks/useViewer';

export const ChatUserContext = React.createContext();

const ChatUserProvider = ({ children }) => {
    const [doesChatUserExist, setDoesUserExist] = useState(null);
    const { viewer } = useViewer();
    const { getMessagingToken, accessToken } = useContext(MessagingTokenContext);
    const { data: dataChatUser } = useChatUserExists(viewer?.id);

    useEffect(() => {
        // is this the right place to initialize this? seems hidden
        // but once there is a Twilio user, it should init messaging automatically
        // where else would it be?
        if (dataChatUser?.data.identity && !accessToken) {
            getMessagingToken();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataChatUser, dataChatUser?.data.identity, accessToken]);

    useEffect(() => {
        if (!dataChatUser) return;
        setDoesUserExist(!!dataChatUser?.data.identity);
    }, [dataChatUser, dataChatUser?.data.identity]);

    return <ChatUserContext.Provider value={{ doesChatUserExist }}>{children}</ChatUserContext.Provider>;
};

ChatUserProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

export default ChatUserProvider;
